// All money math is done in integer cents to avoid floating point errors.
// Denominations are entered as a DOLLAR VALUE (e.g. $40 of ones), not a quantity.

export const BILL_DENOMS = [
  { key: "b1", label: "$1", cents: 100 },
  { key: "b5", label: "$5", cents: 500 },
  { key: "b10", label: "$10", cents: 1000 },
  { key: "b20", label: "$20", cents: 2000 },
  { key: "b50", label: "$50", cents: 5000 },
  { key: "b100", label: "$100", cents: 10000 },
];

export const COIN_DENOMS = [
  { key: "penny", label: "Pennies", cents: 1 },
  { key: "nickel", label: "Nickels", cents: 5 },
  { key: "dime", label: "Dimes", cents: 10 },
  { key: "quarter", label: "Quarters", cents: 25 },
];

export const ALL_DENOMS = [...BILL_DENOMS, ...COIN_DENOMS];

// Parse a user-entered dollar string into integer cents.
export function dollarsToCents(value) {
  const n = parseFloat(value);
  if (isNaN(n)) return 0;
  return Math.round(n * 100);
}

// Format integer cents as a signed $ string.
export function formatCents(cents) {
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  return `${sign}$${(abs / 100).toFixed(2)}`;
}

// Sum the dollar-value inputs for a set of denominations, in cents.
export function sumDenomsCents(values, denoms) {
  return denoms.reduce((t, d) => t + dollarsToCents(values[d.key]), 0);
}

// Parse a non-negative integer quantity.
export function parseQty(value) {
  const n = parseInt(value, 10);
  return isNaN(n) || n < 0 ? 0 : n;
}

// Sum quantity inputs (count of each denomination) into total cents.
export function sumQtyCents(quantities, denoms) {
  return denoms.reduce((t, d) => t + parseQty(quantities[d.key]) * d.cents, 0);
}
